<template>
    <div class="page-setting has-bc biz-add-organization-group-comp">
        <div class="tool-bar-mask"></div>
        <div class="page-header">
            <h1>{{$route.meta.title}}</h1>
            <div class="btn-group">
                <button class="default-button publish" @click="saveData">新增</button>
            </div>
        </div>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                業務分群資訊
            </div>
            <div class="toogle-body" slot="toogle-body">
                <div class="group-name">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span> 業務分群名稱
                        </div>
                        <span v-show="error.groupNameErr" class="error-with-title">{{error.groupNameErr}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.groupNameErr}" type="text" v-model="insertData.groupName" placeholder="請輸入業務分群名稱">
                    </div>
                </div>
                <div class="house-rent">
                    <label class="button-font input-label">
                        <div class="title">備註</div>
                    </label>
                    <div class="input-arear">
                        <input type="text" v-model="insertData.note" placeholder="輸入備註描述">
                    </div>
                </div>
            </div>
        </toogle-block>
    </div>
</template>
<script>
import toogleBlock from '@/components/bussiness/widges/tools/toogleBlock.vue';

import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            insertData: {
                groupName: '',
                note: '',
            },
            error: {
                groupNameErr: '',
            },
        }
    },
    mounted () {
        
    },
    watch: {
        insertData: {
            handler: function (newValue, oldValue) {
                if(newValue.groupName != ''){
                    this.error.groupNameErr = ''
                }else{
                    this.error.groupNameErr = '請填寫業務分群名稱'
                }
            },
            deep: true,
        }
    },
    methods: {
        checkInput: function () {
            if(!this.insertData.groupName){
                this.error.groupNameErr = '請填寫業務分群名稱'
                return false
            }else{
                return true
            }
        },
        saveData: function () {
            if(this.checkInput()){
                this.$analyticsBiz.logEvent('新增業務分群', { screen_name: '新增業務分群'})

                this.$store.dispatch('insertBizOrganizationGroup', this.insertData)
                .then(res => {
                    if( res.data.status == "SUCCESS" ){
                        this.$router.push({ name: 'bizOrganizationGroup', query: { success: '1' }})
                    }else{
                        this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                    }
                })
            }
        },
    },
    computed: {
        ...mapGetters({
            
        })
    },
    components: {
        toogleBlock,
    }
}
</script>
<style lang="scss">
    .biz-add-organization-group-comp{
        .must-fill-alarm{
            position: relative;
            display: flex;
            align-items: center;
            height: 72px;
            margin-bottom: 20px;
            border-radius: 6px;
            box-shadow: 1px 0 10px 0 rgba(41, 38, 37, 0.02);
            border: solid 1px #f3f3f3;
            background-color: #ffffff;
            color: #676362;
            padding: 0 24px;
            .star{
                color: #fc7171;
                margin: 0 2px;
            }
            img{
                margin-right: 2px;
            }
        }
        span.error{
            right: 0;
            top: -27px;
            left: unset;
            bottom: unset;
        }
        .group-name {
            position: relative;
            width: 424px;
            margin-bottom: 24px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/internalAuth/organizationGroup/addOrganizationGroupComp.vue